// Small display helpers shared by the site shell (navbar, home, leaderboard, profile).

const CATEGORY_COLORS = ['var(--c1)', 'var(--c2)', 'var(--c3)', 'var(--c4)'];

// Stable avatar color for a name, picked from the four category colors.
export function avatarColor(name = '') {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0;
  }
  return CATEGORY_COLORS[Math.abs(hash) % CATEGORY_COLORS.length];
}

export function initial(name = '') {
  return (name.trim().charAt(0) || '?').toUpperCase();
}

// Guest display names come from a hash of the guest id, the same way the server derives them
// (server/utils/identity.js), so the header matches what other players see.
export function guestNameFromDigest(bytes) {
  const n = ((bytes[0] << 24) | (bytes[1] << 16) | (bytes[2] << 8) | bytes[3]) >>> 0;
  return `Guest_${n.toString(36).padStart(6, '0').slice(-6)}`;
}

export async function guestName(guestId) {
  if (!guestId || !window.crypto?.subtle) return 'Guest';
  const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(guestId)));
  return guestNameFromDigest(new Uint8Array(digest));
}

// "Tuesday, October 13" from a YYYY-MM-DD string (read as a calendar date, not UTC).
export function formatLongDate(ymd) {
  const parts = typeof ymd === 'string' ? ymd.split('-').map(Number) : null;
  const date = parts && parts.length === 3 ? new Date(parts[0], parts[1] - 1, parts[2]) : new Date();
  return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
}

// "Oct 13, 2026"
export function formatShortDate(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

// 83.4 seconds -> "1:23"
export function formatDuration(seconds) {
  if (seconds === null || seconds === undefined || Number.isNaN(Number(seconds))) return '-';
  const total = Math.max(0, Math.floor(Number(seconds)));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function solveRate(wins, gamesPlayed) {
  if (!gamesPlayed) return '0.0%';
  return `${(((wins || 0) / gamesPlayed) * 100).toFixed(1)}%`;
}
